import type { GuaArticle } from '@/mocks/gua88-news';
import { feedArticles, leadStory } from '@/mocks/gua88-news';
import { SectionHead, TagBadge, TrustBadge } from './articleUi';

export default function Latest({ onRead }: { onRead: (a: GuaArticle) => void }) {
  const sub = feedArticles.slice(0, 3);

  return (
    <section id="latest" className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          kicker="Live · 最热头条"
          title="最新进展"
          desc="按时间倒序跟进 88 余波的最新动态，头条之外还有更多正在发酵的小瓜等你点开。"
        />

        {/* lead story */}
        <article className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="relative">
            <div className="aspect-[16/10] h-full lg:aspect-auto">
              <img
                src={leadStory.image}
                alt={leadStory.title}
                title={leadStory.title}
                className="h-full w-full object-cover"
              />
            </div>
            <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-bold text-background-50">
              <i className="ri-fire-line"></i>
              置顶
            </span>
          </div>
          <div className="flex flex-col p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2">
              <TagBadge tag={leadStory.tag} />
              <TrustBadge trust={leadStory.trust} />
              <span className="text-xs text-foreground-500">{leadStory.time}</span>
            </div>
            <h3 className="mt-3 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
              {leadStory.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
              {leadStory.excerpt}
            </p>
            <div className="mt-auto pt-5">
              <button
                type="button"
                onClick={() => onRead(leadStory)}
                className="inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                阅读全文
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
            </div>
          </div>
        </article>

        {/* sub news */}
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {sub.map((a) => (
            <button
              key={a.id}
              type="button"
              onClick={() => onRead(a)}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 text-left transition-colors hover:border-primary-200"
            >
              <div className="relative overflow-hidden">
                <div className="aspect-[16/10]">
                  <img
                    src={a.image}
                    alt={a.title}
                    title={a.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2 py-0.5 text-[11px] font-medium text-primary-700">
                  {a.time}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center gap-2">
                  <TagBadge tag={a.tag} />
                  <TrustBadge trust={a.trust} />
                </div>
                <h4 className="mt-2.5 font-heading text-[15px] font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">
                  {a.title}
                </h4>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {a.excerpt}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}